import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import Disponibilite from './components/Disponibilite';
import Profile from './components/Profile';
import Experience from './components/Experience';
import TechStack from './components/TechStack';
import Competences from './components/Competences';
import Formation from './components/Formation';
import Projets from './components/Projets';
import SoftSkills from './components/SoftSkills';
import MatrixRain from './components/MatrixRain';
import Footer from './components/Footer';
import { cvData } from './data/cvData';
import './styles/globals.css';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simuler un chargement avec un effet terminal
    const timer = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-dark-bg flex flex-col items-center justify-center font-mono">
        <motion.div
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          className="text-violet-400 text-xl mb-4"
        >
          ~/portfolio $ starting dev environment...
        </motion.div>
        <div className="w-48 h-1 bg-dark-surface rounded-full overflow-hidden">
          <motion.div
            initial={{ x: '-100%' }}
            animate={{ x: '100%' }}
            transition={{ duration: 1, repeat: Infinity }}
            className="w-full h-full bg-gradient-to-r from-violet-500 via-fuchsia-500 to-blue-500"
          />
        </div>
      </div>
    );
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="min-h-screen bg-dark-bg text-gray-100"
      >
        <Header data={cvData.personal} />
        
        <main className="container mx-auto px-4 py-8 max-w-6xl">
          <Hero data={cvData.personal} />
          <Disponibilite data={cvData.disponibilite} />
          <Profile data={cvData.personal} />

          <MatrixRain />
          
          {/* Nouvelle section Tech Stack dynamique (comme zalt.me) */}
          <TechStack technologies={cvData.techStack} />
          
          <Experience experiences={cvData.experiences} />
          <Competences competences={cvData.competences} />
          <Formation formation={cvData.formation} />
          <Projets projets={cvData.projets} />
          <SoftSkills 
            softSkills={cvData.softSkills} 
            interests={cvData.interests}
            objective={cvData.objective}
          />
        </main>
        
        <Footer data={cvData.footer} />
      </motion.div>
    </AnimatePresence>
  );
}

export default App;